<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    List of Accounts
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  name: "DistributorListAccount",
  mixins: [ShareableMethods],

  data() {
    return {
      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          // {
          //   text: "Date",
          //   align: "start",
          //   sortable: false,
          //   value: "createdDate",
          //   formatter: (x) => (x ? moment(x).format("MMMM DD, YYYY") : null),
          // },
          {
            text: "Name",
            value: "name",
          },

          {
            text: "Email Address",
            value: "emailAddress",
            sortable: false,
          },

          {
            text: "Role",
            value: "role",
            sortable: false,
          },

          {
            text: "Active",
            value: "active",
            sortable: false,
          },
        ],
        data: [],
      },
      DID: {
        distributorId: "",
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    // getLabel(verifier, approver) {
    //   return this.getDashboardRole.code === this.$dd_verifier
    //     ? verifier
    //     : approver;
    // },

    async getList() {
      this.table.loading = true;
      const { adminLogin } = this.userData;

      await this.$drs
        .get(
          `/broker/drs/distributor-accounts?distributorId=${adminLogin.distributorId}`
        )
        .then((response) => {
          const newArr = response.data.data;
          console.log(newArr);
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    userData() {
      return this.$store.getters.userData;
    },

    getDashboardRole() {
      return this.$store.getters.dashboardRole;
    },
  },
};
</script>
